/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentSharedCourseRegistrations200,
  GetApiV1IndividualpaymentSharedCourseRegistrations401,
  GetApiV1IndividualpaymentSharedCourseRegistrations500,
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams,
  GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedCourseRegistrations.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentSharedCourseRegistrationsQueryParamsSchema =
  z
    .object({
      personId: z.optional(z.coerce.number().int()),
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentSharedCourseRegistrationsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentSharedCourseRegistrations200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentSharedCourseRegistrations200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentSharedCourseRegistrations401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedCourseRegistrations401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentSharedCourseRegistrations500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedCourseRegistrations500>;

export const getApiV1IndividualpaymentSharedCourseRegistrationsQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentSharedCourseRegistrations200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentSharedCourseRegistrationsQueryResponse>;
